import { ActionTypeEnum } from "~/types";
import { err, ok, Result } from "neverthrow";

import { BaseError, NotFoundError, ValidationError } from "../errors";
import { triggerBrevoContact } from "./trigger-brevo-contact";
import { triggerMetaEvent } from "./trigger-meta-event";

export function attachEventHandlerToElement(
  element: HTMLElement,
  metaEventName: string,
  type: ActionTypeEnum,
  key: string,
): Result<boolean, BaseError> {
  if (type === ActionTypeEnum.META_EVENT) {
    if (element.tagName !== "BUTTON" && element.tagName !== "A") {
      return err(new ValidationError("Element should be a button or a link."));
    }

    element.addEventListener(
      "click",
      (event) => {
        const triggerMetaEventResult = triggerMetaEvent(
          key,
          metaEventName,
          true,
        );

        if (triggerMetaEventResult.isErr()) {
          console.warn(triggerMetaEventResult.error);
        }

        if (element.tagName === "A") {
          event.preventDefault();
          setTimeout(() => {
            window.location.href = (element as HTMLAnchorElement).href;
          }, 50);
        }
      },
      true,
    );
  } else if (type === ActionTypeEnum.BREVO_CONTACT) {
    if (element.tagName !== "FORM") {
      return err(new ValidationError("Element is not a form."));
    }

    const submitElement = element.querySelector(
      `button[type=submit], input[type=submit]`,
    );

    if (!submitElement) {
      return err(new NotFoundError("Form has no submit element."));
    }

    const emailInputField = element.querySelector("input[name='email' i]");

    if (!emailInputField) {
      return err(new NotFoundError("Form has no email field."));
    }

    submitElement.addEventListener(
      "click",
      (event) => {
        event.preventDefault();

        const triggerBrevoContactResult = triggerBrevoContact(
          type,
          key,
          (emailInputField as HTMLInputElement).value,
        );

        if (triggerBrevoContactResult.isErr()) {
          console.warn(triggerBrevoContactResult.error);
        }

        if (form.hasAttribute("action") && form.getAttribute("action") !== "") {
          setTimeout(() => {
            (element as HTMLFormElement).submit();
          }, 50);
        }
      },
      true,
    );
  }

  return ok(true);
}
